import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import Img from '../../assets/images/c4.png';
import api from '../../service/caller';  // Assurez-vous d'importer votre instance API
import { toast } from 'react-toastify';  // Si vous utilisez toast pour afficher les messages d'erreur

const PrescriptionForm = ({ roomId, onAssign }) => {
  const [UserData, setUserData] = useState(null);
  const [patients, setPatients] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [availableBeds, setAvailableBeds] = useState([]);
  const [formData, setFormData] = useState({
    room: roomId || '',  // Pré-remplir avec l'ID de la chambre ou une chaîne vide
    patient: '',
    bed: '',
  });

  // Récupérer les données de l'utilisateur connecté
  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch user data");
        console.error("Failed to fetch user data:", error);
      }
    };
    fetchLoggedUserData();
  }, []);

  // Récupérer les patients en fonction de l'hôpital
  const fetchPatients = async (hospitalId) => {
    if (!hospitalId) {
      console.error("Erreur: hospitalId est", hospitalId);
      return;
    }

    try {
      const response = await api.get(`/clinic/patients?hospitalId=${hospitalId}`);
      setPatients(response.data.patients);
    } catch (error) {
      toast.error('Erreur lors de la récupération des patients');
      console.error('Erreur lors de la récupération des patients:', error);
    }
  };

  useEffect(() => {
    if (UserData && UserData.hospital_id && UserData.hospital_id._id) {
      const hospitalId = UserData.hospital_id._id;
      fetchPatients(hospitalId);
    } else {
      console.error("UserData ou hospital_id non disponible pour fetchPatients");
    }
  }, [UserData]);

  // Récupérer les chambres pour l'hôpital
  useEffect(() => {
    const fetchRooms = async () => {
      if (UserData && UserData.hospital_id && UserData.hospital_id._id) {
        try {
          const response = await api.get(`/api/getrooms/${UserData.hospital_id._id}`);
          setRooms(response.data);
        } catch (error) {
          toast.error("Failed to fetch rooms data");
          console.error("Error fetching rooms:", error);
        }
      }
    };

    if (UserData && UserData.hospital_id) {
      fetchRooms();
    }
  }, [UserData]);

  // Récupérer les lits d'une chambre
  const fetchBedsForRoom = (roomId) => {
    const room = rooms.find((room) => room._id === roomId);
    return room ? room.beds.filter(bed => !bed.isOccupied) : [];
  };

  // Mise à jour des lits disponibles lorsque la chambre change
  const handleRoomChange = (e) => {
    const roomId = e.target.value;
    setFormData((prev) => ({
      ...prev,
      room: roomId,
    }));

    const beds = fetchBedsForRoom(roomId);
    setAvailableBeds(beds);
    setFormData((prev) => ({
      ...prev,
      bed: beds.length > 0 ? beds[0].bedNumber : '', // Prérégler le premier lit disponible
    }));
  };

  // Mise à jour du patient sélectionné
  const handlePatientChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      patient: selectedOption.value,
    }));
  };

  // Assignation du patient au lit sélectionné
  const handleAssign = async () => {
    const { patient, room, bed } = formData;

    if (!patient || !room || !bed) {
      toast.error("Veuillez sélectionner un patient, une chambre et un lit.");
      return;
    }

    try {
      const assignData = {
        patientId: patient,
        roomId: room,  // Assurez-vous que room est un ID de chambre valide
        bedNumber: bed
      };

      const response = await api.put(`/rooms/${room}/assignpatient`, assignData);
      console.log('assignment done!', assignData);

      if (response.status === 200) {
        toast.success(`Patient ${patient} assigné à la chambre ${room} et au lit ${bed}`);
        setAvailableBeds((prevBeds) => prevBeds.filter(b => b.bedNumber !== bed));

        setFormData({
          room: '',
          patient: '',
          bed: '',
        });

        if (onAssign) onAssign(response.data);
      } else {
        toast.error("Erreur lors de l'assignation du patient");
      }
    } catch (error) {
      toast.error("Erreur lors de l'assignation du patient");
      console.error("Error assigning patient:", error);
    }
  };


  // Effectue l'initialisation des lits si une chambre est pré-sélectionnée
  useEffect(() => {
    if (formData.room) {
      const beds = fetchBedsForRoom(formData.room);
      setAvailableBeds(beds);
      setFormData((prev) => ({
        ...prev,
        bed: beds.length > 0 ? beds[0].bedNumber : '',
      }));
    }
  }, [formData.room, rooms]);

  return (
    <div className="prescription-form mt-4">
      <form className="row g-4" onSubmit={(e) => e.preventDefault()}>
        {/* Patient Select */}
        <div className="col-lg-12">
          <div className="form-field selectpatient">
            <label style={{ background: '#EFF7FF' }}>Select Patient</label>
            <Select
              options={patients.map((patient) => ({
                label: `${patient.firstname} ${patient.lastname}`,
                value: patient._id,
              }))}
              onChange={handlePatientChange}
              placeholder="Search and select a patient"
              isSearchable
            />
          </div>
        </div>

        {/* Room Select */}
        <div className="col-lg-12">
          <div className="form-field">
            <label style={{ background: '#EFF7FF' }}>Room</label>
            <select
              className="form-control"
              value={formData.room}
              onChange={handleRoomChange}
            >
              {rooms.map((room) => (
                <option key={room._id} value={room._id}>
                  {room.roomNumber} - {room.type}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Bed Select */}
        <div className="col-lg-12">
          <p><strong>Select bed</strong></p>
          <div className="d-flex flex-wrap justify-content-between">
            {availableBeds.length > 0 ? (
              availableBeds.map((bed) => (
                <div key={bed.bedNumber}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="bed"
                      id={`bed-${bed.bedNumber}`}
                      checked={formData.bed === bed.bedNumber}
                      onChange={() => setFormData((prev) => ({ ...prev, bed: bed.bedNumber }))}
                    />
                    <label className="form-check-label" htmlFor={`bed-${bed.bedNumber}`}>
                      <strong>
                        <img src={Img} alt="Room" className="me-2" style={{ width: '20%' }} />
                        <span>{bed.bedNumber}</span>
                      </strong>
                    </label>
                  </div>
                </div>
              ))
            ) : (
              <p>Aucun lit disponible pour cette chambre</p>
            )}
          </div>
        </div>

        {/* Submit Button */}
        <div className="col-lg-12 text-center">
          <button
            type="button"
            className="btn text-light d-flex align-items-center justify-content-center"
            style={{ borderRadius: '25px', backgroundColor: '#28A745' }}
            onClick={handleAssign}
          >
            <span>Assign</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default PrescriptionForm;
